<template>
  <div class="position-relative">
    <LoaderOverlay
      size="big"
      color="color2"
      v-if="loader"
    />
    <div
      class="d-lg-flex"
    >
      <div class="col-lg-4 pl-0">
        <div class="form-group default-input">
          <TheMask
            :mask="'#####-###'"
            v-model="address.zipcode"
            placeholder=""
            class="form-control with-label"
            @change.native="getCep"
            @input="emitInput"
          />
          <label>CEP</label>
        </div>
      </div>
      <div class="col-lg-8 px-0">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="address.street" @input="emitInput" placeholder="" :readonly="readonlyForm" />
          <label>Endereço</label>
        </div>
      </div>
    </div>
    <div
      class="d-lg-flex"
    >
      <div class="col-lg-4 pl-0">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="address.number" @input="emitInput"  placeholder="" />
          <label>Número</label>
        </div>
      </div>
      <div class="col-lg-4 pl-0">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="address.complement" @input="emitInput"  placeholder="" />
          <label>Complemento</label>
        </div>
      </div>
      <div class="col-lg-4 px-0">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="address.neighborhood" @input="emitInput"  placeholder="" :readonly="readonlyForm" />
          <label>Bairro</label>
        </div>
      </div>
    </div>
    <div
      class="d-lg-flex"
    >
      <div class="col-lg-5 pl-0">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="address.city" @input="emitInput"  placeholder="" readonly />
          <label>Cidade</label>
        </div>
      </div>
      <div class="col-lg-5 px-0">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="address.state" @input="emitInput"  placeholder="" readonly />
          <label>Estado</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getCEPData, parseErrorResponseToArray } from '@/utils'

import LoaderOverlay from '@/components/common/Loader/LoaderOverlay'
import { TheMask } from 'vue-the-mask'

export default {
  name: 'AddressForm',
  props: ['value'],
  components: {
    LoaderOverlay,
    TheMask
  },
  data () {
    return {
      loader: false,
      readonlyForm: true,
      address: {
        street: '',
        number: '',
        zipcode: '',
        city: '',
        state: '',
        neighborhood: '',
        complement: ''
      }
    }
  },
  created () {
    this.address.street = this.value.street
    this.address.number = this.value.number
    this.address.zipcode = this.value.zipcode
    this.address.city = this.value.city
    this.address.state = this.value.state
    this.address.neighborhood = this.value.neighborhood
    this.address.complement = this.value.complement
  },
  methods: {
    async getCep () {
      this.loader = true
      this.$emit('get-zipcode-started')
      try {
        const address = await getCEPData(this.address.zipcode)
        this.address.street = address.street
        this.address.neighborhood = address.neighborhood
        this.address.city = address.city
        this.address.state = address.state
        this.readonlyForm = !!address.street
      } catch (error) {
        this.$emit('error', parseErrorResponseToArray(error))
      }
      this.loader = false
    },
    emitInput () {
      this.$emit('input', this.address)
    }
  }
}
</script>
